<div class="row">
  <div class="col-4">
    <label>{{ 'Categories' | translate }}</label>
    <sanabel-selectize appcode="14371" [(ngModel)]="categorySerial" #categorySelectize [SearchKeys]="{parentSerial:0}"
      [simpleView]="true" (clicked)="categoryClicked()"></sanabel-selectize>
  </div>
  <div class="col-4">
    <label>{{ 'SUBCATEGORIES' | translate }}</label>
    <sanabel-selectize appcode="14371" [(ngModel)]="subCategorySerial" #subCategorySelectize
      [SearchKeys]="{parentSerial:categorySerial}" [simpleView]="true"
      (clicked)="subCategoryClicked()"

      ></sanabel-selectize>
  </div>
  <div class="col-4">
    <label>{{ 'INTERVENTIONS' | translate }}</label>
    <sanabel-selectize appcode="14371" #interventionsSelectize [SearchKeys]="{parentSerial:subCategorySerial}"
      [simpleView]="true"></sanabel-selectize>
  </div>
</div>

<div class="container mt-4">
  <h2 class="mb-4">Track Infection Control Plans</h2>

  <!-- Plan Selection -->
  <form (ngSubmit)="onSubmit()" #trackingForm="ngForm">
    <div class="mb-3">
      <label for="planSelect" class="form-label">Select Plan</label>
      <select class="form-select" id="planSelect" [(ngModel)]="selectedPlan" name="selectedPlan" required
        (change)="loadPlanDetails()">
        <option *ngFor="let plan of plans" [ngValue]="plan">{{ plan.name }}</option>
      </select>
    </div>

    <!-- Plan Details -->
    <div *ngIf="selectedPlan">
      <h4>Plan Details</h4>
      <p><strong>Description:</strong> {{ selectedPlan.description }}</p>
      <p><strong>Responsible Person:</strong> {{ selectedPlan.responsiblePerson }}</p>
      <p><strong>Timeline:</strong> {{ selectedPlan.timeline | date }}</p>

      <!-- Interventions Progress -->
      <h4>Interventions Progress</h4>
      <ul class="list-group">
        <li *ngFor="let intervention of selectedPlan.selectedInterventions"
          class="list-group-item d-flex justify-content-between align-items-center">
          {{ intervention.name }}
          <span>
            <input type="checkbox" [(ngModel)]="intervention.completed" name="intervention_{{intervention.name}}"
              class="form-check-input" (change)="updateProgress()">
            Completed
          </span>
        </li>
      </ul>

      <!-- Overall Progress -->
      <div class="mt-4">
        <h4>Overall Progress</h4>
        <div class="progress">
          <div class="progress-bar" role="progressbar" [style.width.%]="selectedPlan.progress"
            aria-valuenow="selectedPlan.progress" aria-valuemin="0" aria-valuemax="100">{{ selectedPlan.progress }}%
          </div>
        </div>
      </div>
    </div>

    <!-- Submit Button -->
    <div class="mt-4">
      <button type="submit" class="btn btn-primary" [disabled]="!trackingForm.form.valid">Submit</button>
    </div>
  </form>
</div>